import { filterOptions } from '@/utils/query-base'

const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export const pageSearch = {
  'ZZFLD000002': {
    title: '省',
    equation: city,
    type: 'select',
    dictionary: 'region'
  },
  'ZZFLD000003': {
    title: '市',
    equation: city,
    type: 'select',
    dictionary: 'city'
  }
}

export default {
  'object_id': {
    title: '销售订单编号',
    type: 'input',
    equation: cusname,
    slot: true
  },
  'process_type': {
    describe: true,
    title: '订单类型',
    type: 'select',
    equation: city,
    dictionary: 'A0043'
  },
  'status': {
    describe: true,
    title: '订单状态',
    type: 'select',
    equation: city,
    dictionary: 'A0041'
  },
  'hk_status': {
    title: '货款校验状态',
    type: 'input'
  },
  'customer': {
    title: '客户编号',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '客户编号'
    },
    unSearchRole: 'WLY001'
  },
  'cust_name': {
    title: '客户名称',
    type: 'input',
    equation: cusname,
    width: 200,
    unSearchRole: 'WLY001'
  },
  'customer_type': {
    describe: true,
    title: '客户类型',
    type: 'select',
    equation: city,
    dictionary: 'A0009',
    unSearchRole: 'WLY001'
  },
  'zzfld000001': {
    describe: true,
    title: '营销单元',
    type: 'select',
    equation: all,
    dictionary: 'sale',
    unSearchRole: 'WLY001'
  },
  'zzfld00003e': {
    describe: true,
    title: '基地',
    type: 'select',
    equation: all,
    dictionary: 'base',
    unSearchRole: 'WLY001'
  },
  'all_price': {
    title: '整单价税合计',
    xlsxFmt: {
      t: 'n'
    }
  },
  'all_quantity': {
    title: '整件件数合计',
    xlsxFmt: {
      t: 'n'
    }
  },
  'posting_date': {
    title: '订单创建日期',
    type: 'date',
    equation: all,
    defaultVal: new Date()
  },
  'zzfld00002d_dscr': {
    title: '创建人',
    type: 'input',
    equation: all,
    width: 150
  },
  'zzfld00002j': {
    describe: true,
    title: '运达方类型',
    type: 'select',
    equation: city,
    dictionary: 'A0009'
  },
  'zzfld00008t': {
    title: '运达方编码',
    type: 'input',
    equation: cusname
  },
  'zzfld00008t_dscr': {
    title: '运达方名称',
    type: 'input',
    equation: cusname
  },
  'zzfld00002l': {
    title: '收货人联系人',
    type: 'input',
    equation: cusname
  },
  'zzfld00002m': {
    title: '收货联系人电话',
    type: 'input',
    equation: cusname,
    width: 150
  },
  'zzfld00002n': {
    title: '收货地址',
    type: 'input',
    equation: cusname
  },
  'zzfld000028': {
    title: '抬头备注',
    type: 'input',
    equation: cusname
  },
  'zzfld00003c': {
    title: '订单来源',
    type: 'input',
    equation: cusname
  }

}



// WEBPACK FOOTER //
// ./src/views/order-manage/config/salesOrderList.js